/** Partha payment modes, 16 October 2026. Received money only; no authorization/settlement state. */
export const PAYMENT_MODE_LABELS: Readonly<Record<string,string>> = {
  cash:'Cash', upi:'UPI', credit:'Credit', emi:'EMI', government_schemes:'Government schemes',
  cheque:'Cheque', online:'Online', link:'Link', card:'Card', other:'Others',
};
export const PAYMENT_MODE_OPTIONS = Object.keys(PAYMENT_MODE_LABELS);
export const PAYMENT_SUBTYPES: Readonly<Record<string,Readonly<Record<string,string>>>> = {
  credit:{mdp:'MDP',medibuddy:'MediBuddy',other:'Others'},
  emi:{bajaj:'Bajaj',carepay:'CarePay',opine_labs:'Opine Labs',fibe:'Fibe',other:'Others'},
  government_schemes:{ehs:'EHS',echs:'ECHS',abs:'ABS',absspf:'ABSSPF',narl:'NARL'},
  card:{credit:'Credit',debit:'Debit'},
};
export interface PaymentMethodDetails {
  readonly method?: string|null;
  readonly methodSubtype?: string|null;
  readonly methodOtherName?: string|null;
  readonly referenceNumber?: string|null;
}
export function paymentMethodDetailsError(value:PaymentMethodDetails):string|null {
  const {method,methodSubtype,methodOtherName,referenceNumber}=value;
  if(!method || !Object.prototype.hasOwnProperty.call(PAYMENT_MODE_LABELS,method))return 'Pick a payment method.';
  const subtypes=PAYMENT_SUBTYPES[method];
  if(subtypes ? !methodSubtype || !Object.prototype.hasOwnProperty.call(subtypes,methodSubtype) : !!methodSubtype)return 'Pick a valid sub-type for this method.';
  const other=method==='other'||methodSubtype==='other';
  if(other ? !methodOtherName?.trim() || methodOtherName.trim().length>80 || /[\x00-\x1f\x7f]/.test(methodOtherName) : !!methodOtherName)return 'Enter the Others name (up to 80 characters).';
  if(method==='cash')return referenceNumber ? 'Cash does not use a reference number.' : null;
  return referenceNumber && /^[A-Za-z0-9][A-Za-z0-9/._-]{0,63}$/.test(referenceNumber.trim()) ? null : 'Enter a valid reference number (up to 64 characters).';
}
/** Mode, sub-type and Others name only: for surfaces that show the reference in its own field. */
export function paymentModeDescription(value:PaymentMethodDetails):string {
  const raw=value.method;
  if(!raw)return 'Not recorded';
  const legacy:Record<string,string>={insurance:'Insurance',bank_transfer:'Bank transfer'};
  let mode=PAYMENT_MODE_LABELS[raw]??legacy[raw]??raw.replace(/_/g,' ');
  let subtype=value.methodSubtype ? PAYMENT_SUBTYPES[raw]?.[value.methodSubtype]??value.methodSubtype : '';
  if(value.methodOtherName){if(raw==='other')mode+=` (${value.methodOtherName})`;else if(value.methodSubtype==='other')subtype+=` (${value.methodOtherName})`;}
  return [mode,subtype].filter(Boolean).join(' \u00b7 ');
}
/** Historical missing metadata stays missing. Never infer a provider or rewrite old method tokens. */
export function paymentMethodDescription(value:PaymentMethodDetails):string {
  const mode=paymentModeDescription(value);
  return value.method && value.referenceNumber ? `${mode} \u00b7 ${value.referenceNumber}` : mode;
}
/** The reference field: Cash takes none (an em dash), a missing non-cash reference stays "Not recorded". */
export function paymentReferenceDisplay(value:PaymentMethodDetails):string {
  if(value.referenceNumber)return value.referenceNumber;
  return value.method==='cash' ? '\u2014' : 'Not recorded';
}
